export const environment = {
  production: false,
  auth: {
    authority: 'https://acciona-sb.onelogin.com/oidc/2',
    oneLoginWellKnownUrl: 'https://acciona-sb.onelogin.com/oidc/2',
    clientID: '3c5e0890-a30c-013c-8535-56f5c2a9a62838690',
    redirectUri: 'http://localhost:4200',
    postLogoutRedirectUri: 'http://localhost:4200',
    scopes: 'openid profile email',
    protectedResourceMap: [ 'http://localhost:4200/api' ],
    omniChannelDataAppId: '4d1b1643-bd43-4591-9da8-5433e710a78f',
    omniChannelDataOrgId: '4c89471c-6612-4ec5-911c-7a3d973cec1d',
    omniChannelDataOrgUrl: 'https://m-4c89471c-6612-4ec5-911c-7a3d973cec1d.eu.omnichannelengagementhub.com',
  },
  prefixes: {
    default: 'http://localhost:4200/api',
  },
  host: '',
  feverThreshold: '37',
  url: {
    login: '/User/authuser/pais',
    home: {
      buscador: '/Home/buscador'
    },
    grandesCuentas: {
      getAvisosRiesgo: '/Home/grandesCuentas/avisosriesgos',
      getContractsNextExpiration: '/Home/grandesCuentas/contratosAFinalizar',
      getAnnualSales: '/Home/grandesCuentas/graficaVentas',
      getObjectives: '/Home/grandesCuentas/objetivos',
      setObjectives: '/Home/grandesCuentas/objetivos',
      customers: {
        getTradingAcounts: '/Cliente/grandesCuentas/cuentasNegociadoras',
        getTradingAcountsDetail: '/Cliente/grandesCuentas/cuentasNegociadoras/{idCuentaNegociadora}',
        getSocialReasons: '/Cliente/grandesCuentas/cuentasNegociadoras/{idCuentaNegociadora}/razoneSociales',
        getSocialReasonsDetail: '/Cliente/grandesCuentas/cuentasNegociadoras/razoneSociales/{idRazonSocial}',
        getSocialReasonsDetailWithCif: '/v3/Clientes/razonSocial/{cif}/detail',
        getSocialReasonsDetailCancelled: '/Cliente/grandesCuentas/cuentasNegociadoras/razoneSociales/{idRazonSocial}/baja',
        getBills: '/Cliente/grandesCuentas/cuentasNegociadoras/razoneSociales/{idRazonSocial}/facturas',
        getNextExpiration: '/Cliente/grandesCuentas/contratosProximos',
        getRiskWarning: '/Cliente/grandesCuentas/avisosRiesgos',
        getExcelTradingAccounts: '/Cliente/grandesCuentas/cuentasNegociadoras/excel',
        getExcelNextExpiration: '/Cliente/grandesCuentas/contratosProximos/excel',
        getExcelRiskWarning: '/Cliente/grandesCuentas/avisosRiesgos/excel',
        getExcelSocialReasons: '/Cliente/grandesCuentas/razonesSociales/excel',
        getBillsExcelFile: '/Cliente/grandesCuentas/cuentasNegociadoras/razoneSociales/{idRazonSocial}/facturas/excel',
      },
      offers: {
        getAccounts: '/Ofertas/cuentasnegociadoras',
        getBusinesses: '/Ofertas/razonessociales',
        getInstallations: '/Ofertas/instalaciones',
        getCampaigns: '/Ofertas/campanias',
        getFile: '/Ofertas/fichero',
        setOffer: '/Ofertas'
      },
    },
    pymes: {
      getContractsNextExpiration: '/Home/pymes/contratosAFinalizar',
      getNewContracts: '/v3/Home/getLatestContracts',
      getNewContractsPT: '/Home/pymes/segumientocontratacion',
      getCommercialPortfolio: '/Home/pymes/listRS',
      newContract: {
        validateCups: '/Contrato/contrato/cups/{cups}',
        validateCif: '/Contrato/contrato/cif',
        altaRazonSocial: '/v3/Contratos/razonSocial/monopunto',
        altaContrato: '/v3/Contratos/contrato/monopunto',
        createContractAsync: '/v3/Contratos/contrato/monopunto/async',
        altaInstalacion: '/Contrato/contrato/instalacion',
        searchCommercials: '/Contrato/contrato/comerciales',
        draft: '/Contrato/contrato/borrador/{idBorrador}',
        checkCreatedContractAsync: '/Contrato/seguimiento/{identificador}'
      },
      customers: {
        getSocialReasons: '/v3/Clientes/razonesSociales',
        getSocialReasonsPT: '/Cliente/pymes/razoneSociales',
        getSocialReasonsCancelled: '/Cliente/pymes/contratos/baja',
        getInstallationV3: '/v3/Clientes/{cif}/activeContracts',
        getInstallation: '/Cliente/pymes/razoneSociales/{idRazonSocial}/instalaciones',
        getInstallationCancelled: '/Cliente/pymes/razoneSociales/{idRazonSocial}/instalaciones/baja',
        getInstallationDetail: '/Cliente/pymes/razoneSociales/instalaciones/{idInstalacion}',
        getBills: '/Cliente/pymes/razoneSociales/instalaciones/{idInstalacion}/facturas',
        getBillsV3: '/v3/Clientes/{cups}/invoices',
        getNextExpiration: '/Cliente/pymes/contratosProximos',
        getNextExpirationV3: '/v3/Clientes/proximosVencimientosContracts',
        getExcelSocialReasons: '/v3/Clientes/razonesSociales/excel',
        getExcelSocialReasonsPT: '/Cliente/pymes/razonesSociales/excel',
        getExcelSocialReasonsCancelled: '/Cliente/pymes/contratos/baja/excel',
        getExcelSocialReasonsCancelledV3: '/v3/Clientes/bajaContracts/excel',
        getExcelNextExpiration: '/Cliente/pymes/contratosProximos/excel',
        getExcelNextExpirationV3: '/v3/Clientes/proximosVencimientosContracts/excel',
        getExcelSocialReason: '/Cliente/pymes/razoneSociales/{idRazonSocial}/instalaciones/excel',
        getExcelSocialReasonV3: '/v3/Clientes/{cif}/activeContracts/excel',
        getExcelSocialReasonCancelled: '/Cliente/pymes/razoneSociales/{idRazonSocial}/instalaciones/excel/baja',
        getContractDetail: '/Cliente/contrato/{codCrm}',
        getBillsExcelFile: '/v3/Clientes/{cups}/invoices/excel',
        getBillsExcelFilePT: '/Cliente/pymes/razoneSociales/instalaciones/{idInstalacion}/facturas/excel',
        getContractsCancelledV3: '/v3/Clientes/bajaContracts',
        getSocialReasonsDetail: '/v3/Clientes/razonSocial/{cif}/detail'
      }
    },
    maestros: {
      getCampaigns: '/Maestros/campanasUser',
      getCampaignsPT: '/Maestros/campanasUser/tensionCicloPeriodo',
      getTipoVia: '/Maestros/tiposVias',
      getCodigoPostal: '/Maestros/poblacion/{codPostal}',
      getSocialReasons: '/Maestros/razonesSociales',
      getSocialReasonsCancelled: '/Maestros/razonesSociales/baja',
      getInstallations: '/Maestros/instalaciones',
      getTradingAccounts: '/Maestros/cuentasNegociadoras',
      getOffers: '/Maestros/ofertas',
      getCups: '/Maestros/cups',
      getCupsCancelled: '/Maestros/cups/baja',
      getCif: '/Maestros/documento',
      getCifCancelled: '/Maestros/documento/baja',
      getContactoComercial: '/Maestros/contactoComercial',
      getContactoComercialCancelled: '/Maestros/contactoComercial/baja',
      getTelefono: '/Maestros/contactoComercial/telefono',
      getContratos: '/Maestros/contratos',
      getConsultoras: '/Maestros/consultoras',
      getOpinionCredito: '/Maestros/opinioncredito',
      getClasificacionCredito: '/Maestros/clasificacioncredito',
      getInstallationsByNameCups: '/Maestros/instalacionesByNombreCups',
      getInstallationsBySocialReason: '/Maestros/instalacionesByRazonSocial',
      getReasonCessation: '/Maestros/motivosBajaIncidencias',
      getTypeContract: '/Maestros/tiposContrato',
      postCheckIbanRS: '/Maestros/contratos/chequeoIbanRS',
      statusBills: '/Maestros/estadosfacturas',
      tensionCyclePeriod: '/Maestros/tensionCicloPeriodo',
      getInvoices: '/v3/Maestros/invoices',
      getInvoicesPT: '/Maestros/facturas',
      getFilterSocialReasonsOptions: '/Maestros/razonesSociales/casos',
      getFilterCupsOptions: '/Maestros/cups/casos',
      getFilterProcessOptions: '/Maestros/tiposCasos/{idioma}',
      getFilterCaseCodeOptionsProcedure: '/Maestros/casosByUser/gestion',
      getFilterCaseCodeOptionsManagement: '/Maestros/casosByUser/tramite',
      getFilterCaseCodeOptionsHistorical: '/Maestros/casosByUser/historico',
      getSocialReasonsV3PymesDetail: '/v3/Maestros/razonesSociales',
      getSocialReasonsV3NextExpiration: '/v3/Maestros/razonesSociales/vencimientos',
      getSocialReasonsV3Cancelled: '/v3/Maestros/razonesSociales/baja',
      getSocialReasonsV3Drafts: '/v3/Maestros/razonesSociales/borradores',
      getSocialReasonsV3InProgress: '/v3/Maestros/razonesSociales/seguimiento',
      getSocialReasonsV3Allcontracts: '/v3/Maestros/razonesSociales/allContracts',
      getCupsV3PymesDetail: '/v3/Maestros/cups',
      getCupsV3NextExpiration: '/v3/Maestros/cups/vencimientos',
      getCupsV3Cancelled: '/v3/Maestros/cups/baja',
      getCupsV3Drafts: '/v3/Maestros/cups/borradores',
      getCupsV3InProgress: '/v3/Maestros/cups/seguimiento',
      getCupsV3Allcontracts: '/v3/Maestros/cups/allContracts',
      getCommercialV3PymesDetail: '/v3/Maestros/comercialCanal',
      getCommercialV3Pymes: '/v3/Maestros/contactosComerciales',
      getCommercialV3NextExpiration: '/v3/Maestros/comercialCanal/vencimientos',
      getCommercialV3Cancelled: '/v3/Maestros/comercialCanal/baja',
      getCommercialV3Drafts: '/v3/Maestros/comercialCanal/borradores',
      getCommercialV3InProgress: '/v3/Maestros/comercialCanal/seguimiento',
      getCommercialV3Allcontracts: '/v3/Maestros/comercialCanal/allContracts',
      getContractV3PymesDetail: '/v3/Maestros/contratos',
      getContractV3NextExpiration: '/v3/Maestros/contratos/vencimientos',
      getContractV3Cancelled: '/v3/Maestros/contratos/baja',
      getContractV3Drafts: '/v3/Maestros/contratos/borradores',
      getContractV3InProgress: '/v3/Maestros/contratos/seguimiento',
      getContractsV3Allcontracts: '/v3/Maestros/contratos/allContracts',
      getCampaignV3PymesDetail: '/v3/Maestros/campaña',
      getCampaignV3NextExpiration: '/v3/Maestros/campaña/vencimientos',
      getCampaignV3Cancelled: '/v3/Maestros/campaña/baja',
      getCampaignV3Drafts: '/v3/Maestros/campaña/borradores',
      getCampaignV3InProgress: '/v3/Maestros/campaña/seguimiento',
      getCampaignV3Allcontracts: '/v3/Maestros/campaña/allContracts',
      getContractsTypeV3: '/v3/Maestros/tiposContratos',
      getPriceLevelTracing: '/v3/Maestros/nivelesPrecios',
      getContractsStatusV3: '/v3/Maestros/estadosContratos',
      getDraftsContractsTypeV3: '/v3/Maestros/tiposContratos/borradores',
      getDraftsPriceLevelV3: '/v3/Maestros/nivelesPrecios/borradores',
      getSelfConsumptionType: '/v3/Maestros/autoConsumos',
      getInstallationType: '/v3/Maestros/tipoInstalacion',
      getSubsectionType: '/v3/Maestros/tipoSubseccion',
      getCupsType: '/v3/Maestros/tipoCups',
    },
    contrato: {
      getFicheroContrato: '/v3/Contratos/contrato/{codContrato}/fichero',
      setFicheroContrato: '/Contrato/contrato/finalizarproceso',
      setFicheroContratoAsync: '/Contrato/contrato/finalizarproceso/async',
      getTracing: '/Contrato/contrato/seguimiento',
      getTracingFilter: '/Contrato/contrato/seguimiento/filtros',
      getDraft: '/Contrato/contrato/borrador',
      getDraftV3: '/v3/Seguimiento/borradoresByUser',
      getDraftFilter: '/Contrato/contrato/borrador/filtros',
      getDraftDetail: '/Contrato/contrato/borrador/{idBorrador}',
      digitalSignature: '/Contrato/contrato/firmaDigital',
      digitalSignatureAsync: '/Contrato/contrato/firmaDigital/async',
      digitalSignatureGC: '/Contrato/contrato/grandesCuentas/firmaDigital',
      downloadTemplate: '/Recursos/contracttemplate/download',
      putQueryOffer: '/Contrato/oferta',
      setContractGC: '/Contrato/contrato/contratoGrandesCuentas',
      getContractGC: '/Contrato/contrato/grandesCuentas/fichero',
      getContractRenovate: '/Contrato/{codContrato}',
      queryCifRenovate: '/Contrato/contrato/{contrato}/renovacion/cif',
      putRenovateContract: '/v3/Contratos/renovacion/monopunto',
      putRenovateContractAsync: '/v3/Contratos/renovacion/monopunto/async',
      getSepa: '/Contrato/contrato/{codContrato}/mandatosepa',
      postAttachedFile: '/Contrato/contrato/adjunto',
      postAttachedFileAsync: '/Contrato/contrato/adjunto/async',
      queryCifMultiPoint: '/ContratoMultiPunto/cif/{cif}/{codCrmUser}',
      saveDraftMultiPoint: '/ContratoMultiPunto/borrador/{idBorrador}',
      getDraftMultiPoint: '/ContratoMultiPunto/borrador/{idBorrador}',
      socialReasonMultipoint: '/v3/Contratos/razonSocial/multipunto',
      validateCups: '/ContratoMultiPunto/cups/{cups}/borrador/{idBorrador}',
      downloadTemplateMultipoint: '/Recursos/installationstemplate/download',
      postInstallation: '/ContratoMultiPunto/instalacion',
      getCampaignsMultipoint: '/ContratoMultiPunto/campanias/{idBorrador}',
      getCampaignsMultipointPT: '/ContratoMultiPunto/campanias/cicloTensionPeriodo/{idBorrador}',
      postContractMultipoint: '/v3/Contratos/contrato/multipunto/async',
      getContractTemplate: '/Recursos/contractmptemplate/download',
      getContractsPendingPT: '/ContratoMultiPunto/seguimiento/user',
      getContractsPending: '/v3/Seguimiento/userNotifications',
      getSepaMultipoint: '/ContratoMultiPunto/contrato/{codContrato}/mandatosepa',
      notificationsMarkAsViewedPT: '/ContratoMultiPunto/seguimiento/markviewed',
      notificationsMarkAsViewed: '/v3/Seguimiento/markviewed',
      cancelDraft: '/Contrato/contrato/borrador/{idBorrador}',
      cancelContract: '/Contrato/contrato/{codContrato}',
      getAttachmentsDraft: '/Contrato/{codContrato}/borrador/adjunto',
      postAttachmentsDraft: '/Contrato/borrador/adjunto',
      deleteAttachmentsDraft: '/Contrato/borrador/adjunto/{idFicheroAdjunto}',
      putInfoManualSips: '/Contrato/InfoManualSIPS',
      getTracingRefactor: '/v3/Seguimiento/parents',
      getTracingDetailRefactor: '/v3/Seguimiento/{idContratoCRM}/details',
      getTracingDetailDCTMRefactor: '/v3/Seguimiento/{idContratoCRM}/dctmRegisters',
      getTracingChildrenRefactor: '/v3/Seguimiento/{contractNum}/children',
      headerDownloadFile: '/v3/Contratos/allContracts/excel/{idFichero}',
    },
    campanas: {
      getCampanas: '/Campanas',
      setCampana: '/Campanas',
      getDetallesCampana: '/Campanas/{idCampana}',
      getNivelesCampana: '/Campanas/{codCrm}/niveles/tarifas',
      getFile: '/Campanas/{codCampaign}/{zona}/{nivel}/fichero',
      getExcelFile: '/Campanas/excel',
      maestros: {
        getProducts: '/Campanas/maestro/productos',
        getFees: '/Campanas/maestro/tarifas',
        getGeoZones: '/Campanas/maestro/zonasGeograficas'
      }
    },
    customers: {
      downloadBill: '/Cliente/factura/fichero',
      downloadBillv3: '/v3/Clientes/invoice/{iddctm}',
      twoWayCommunicationSend: '/ComunicacionBidireccional',
      twoWayCommunication: '/ComunicacionBidireccional/{idDCTM}'
    },
    incidences: {
      incidence: '/Incidencias/incidencias',
      incidenceDetail: '/Incidencias/incidencia/{codIncidencia}/detalle',
      incidenceHistorical: '/Incidencias/historicoIncidencias',
      incidenceHistoricalDetail: '/Incidencias/historicoIncidencia/{idIncidencia}/detalle',
      incidenceUpdate: '/Incidencias/incidencia/{codIncidencia}/update',
      incidenceClose: '/Incidencias/incidencia/{codIncidencia}/close',
      newIncidence: '/Incidencias/incidencia',
      attachFile: '/Incidencias/incidencia/{codIncidencia}/fichero',
      typesIncidences: '/Incidencias/tiposIncidencias',
      categoriesIncidences: '/Incidencias/categoriasIncidencias',
      levelsIncidences: '/Incidencias/nivelesIncidencias',
      statusIncidences: '/Incidencias/estadosIncidencias',
      teamsIncidences: '/Incidencias/equiposReasignacion',
      getInvoiceRequest: '/Incidencias/incidenciaSolicitudFactura/{codIncidencia}/detalle',
      getPaymentRequest: '/Incidencias/incidenciaAplazamientoPago/{codIncidencia}/detalle',
      getBankCharge: '/Incidencias/incidenciaDesgloseCargoBancario/{codIncidencia}/detalle',
      getChangePotency: '/Incidencias/incidenciaCambioPotenciaTarifa/{codIncidencia}/detalle',
      getSurrogateContract: '/Incidencias/incidenciaCambioTitularContrato/{codIncidencia}/detalle',
      getChangeCnae: '/Incidencias/incidenciaCambioRazonSocialCNAE/{codIncidencia}/detalle',
      getActivityCessation: '/Incidencias/incidenciaBajaCeseActividad/{codIncidencia}/detalle',
      getBillingAddress: '/Incidencias/incidenciaCambioDireccionFacturacion/{codIncidencia}/detalle',
      getBankAccount: '/Incidencias/incidenciaCambioCuentaBancaria/{codIncidencia}/detalle',
      getContactInformation: '/Incidencias/incidenciaSolicitudCambioDatosContacto/{codIncidencia}/detalle',
      getSignedContract: '/Incidencias/incidenciaSolicitudCopiaContratoFirmado/{codIncidencia}/detalle',
      getInfoInvoiceRequest: '/Incidencias/informacionConceptoFactura/{codIncidencia}/detalle',
      getInvoiceEmitted: '/Incidencias/incidenciaDiscrepanciaMedidasFacturaEmitida/{codIncidencia}/detalle',
      getInvoicePowerEmitted: '/Incidencias/incidenciaDiscrepanciaPotenciasFacturaEmitida/{codIncidencia}/detalle',
      getInvoiceConceptEmitted: '/Incidencias/incidenciaDiscrepanciaOtrosConceptosFacturaEmitida/{codIncidencia}/detalle',
      getFailure: '/Incidencias/incidenciaCortesAverias/{codIncidencia}/detalle',
      getEmitInvoice: '/Incidencias/incidenciaRetrasoEmisionFacturas/{codIncidencia}/detalle',
      getOtherArrangements: '/Incidencias/incidenciaOtrasGestiones/{codIncidencia}/detalle',
      postChangePotency: '/Incidencias/incidenciaCambioPotenciaTarifa',
      postPaymentRequest: '/Incidencias/incidenciaAplazamientoPago',
      postInvoiceRequest: '/Incidencias/incidenciaSolicitudFactura',
      postFailure: '/Incidencias/incidenciaCortesAverias',
      postChangeCnae: '/Incidencias/incidenciaCambioRazonSocialCNAE',
      postBankCharge: '/Incidencias/incidenciaDesgloseCargoBancario',
      postInvoiceConceptEmitted: '/Incidencias/incidenciaDiscrepanciaOtrosConceptosFacturaEmitida',
      postInvoiceEmitted: '/Incidencias/incidenciaDiscrepanciaMedidasFacturaEmitida',
      postInvoicePowerEmitted: '/Incidencias/incidenciaDiscrepanciaPotenciasFacturaEmitida',
      postEmitInvoice: '/Incidencias/incidenciaRetrasoEmisionFacturas',
      postActivityCessation: '/Incidencias/incidenciaBajaCeseActividad',
      postBillingAddress: '/Incidencias/incidenciaCambioDireccionFacturacion',
      postSurrogateContract: '/Incidencias/incidenciaCambioTitularContrato',
      postBankAccount: '/Incidencias/incidenciaCambioCuentaBancaria',
      postInfoInvoiceRequest: '/Incidencias/informacionConceptoFactura',
      postContactInformation: '/Incidencias/incidenciaSolicitudCambioDatosContacto',
      postSignedContract: '/Incidencias/incidenciaSolicitudCopiaContratoFirmado',
      getToManageIncidencesExcel: '/Incidencias/AGestionar/excel',
      getInProgressExcel: '/Incidencias/EnTramite/excel',
      getHistoricalIncidencesExcel: '/Incidencias/historicoIncidencias/excel',
      getNotificationsCases: '/Incidencias/notificaciones/casos',
      putUpdateNotifications: '/Incidencias/notificaciones/update',
      getOtherArrangementsType: '/Incidencias/tipoGestiones',
      postOtherArrangements: '/Incidencias/incidenciaOtrasGestiones',
      postSelfConsumption: '/Incidencias/incidenciaAutoconsumo',
      getSelfConsumption: '/Incidencias/incidenciaAutoconsumo/{codIncidencia}/detalle'
    },
    recursos: {
      getCategory: '/Recursos/categoria',
      getResourcesFromCategory: '/Recursos/categoria/{categoriaId}',
      getResource: '/Recursos/{recursoId}/download',
      getFileChangeHolder: '/Recursos/caso/cambioTitular/download',
      getFileFeePotency: '/Recursos/caso/tarifaPotencia/download',
      createResource: '/Recursos',
      deleteResource: '/Recursos/{recursoId}',
      getFileCessationActivity: '/Recursos/caso/bajacese/download',
      getFileEndContract: '/Recursos/caso/bajacontratonosuministros/download',
    },
    user: {
      getManagers: '/User/gestoresCanal',
      getCommercials: '/User/ComercialesCanal',
      setUser: '/User/usuario',
      deleteUser: '/User/usuario/{codUsuario}',
      getUserManagers: '/User/{userRole}/padres',
      getLevelsUsers: '/User/HierarchyLevel/{codConsultora}',
      getChannels: '/User/consultoras',
      putReassign: '/User/ReasignarUsuarios',
      getUserImpersonalized: '/User/changeImpersonalizedUser',
      lastAccess: '/User/fechaUltimoAcceso',
      changePassword: '/v3/Users/resetPassword',
      deleteFactors: '/User/onelogin/factors',
    },
    tracing: {
      getOffers: '/Seguimiento/seguimiento/ofertas',
      getContracts: '/Seguimiento/seguimiento/contratos',
      getFile: '/Contrato/contrato/grandesCuentas/descargafichero',
      getDataIncidentFiles: '/Seguimiento/incidencia/{codContrato}/ficheros',
      sendIncidentComment: '/Seguimiento/incidencia/comentario',
      getIncidentFile: '/Seguimiento/incidencia/fichero',
      sendIncidentFiles: '/Seguimiento/incidencia/{codContrato}/fichero',
      getDraftContract: '/Seguimiento/BorradorContratos',
      putApproveCifExperian: '/Seguimiento/approvecifexperian',
      getFiltersDraftContract: '/Seguimiento/BorradorContratos/Filtros',
      getSipManual: '/Seguimiento/SipManual',
      getDraftContractExcelFile: '/Seguimiento/BorradorContratos/excel',
      getSipManualExcelFile: '/Seguimiento/SipManual/excel',
      getContractsDraftExcelFilePT: '/Contrato/contrato/borrador/excel',
      getContractsDraftExcelFile: '/v3/Seguimiento/borradoresByUser/excel',
      getContractsTracingExcelFilePT: '/Contrato/contrato/seguimiento/excel',
      getContractsTracingExcelFile: '/v3/Seguimiento/parents/excel',
      getOfferExcel: '/Seguimiento/seguimiento/ofertas/excel',
      getContractExcel: '/Seguimiento/seguimiento/contratos/excel',
      deleteCreditAnalysisInfoByUser: '/Seguimiento/seguimiento/clearInfoAnalisisCrediticioByUser',
      postCreditAnalysisInfo: '/Seguimiento/seguimiento/infoAnalisisCrediticio',
      getCreditAnalysisInfoUser: '/Seguimiento/seguimiento/infoAnalisisCrediticioUsuario',
      getCreditAnalysisExcel: '/Seguimiento/seguimiento/excel/ficheroAnalisisCrediticio',
      getAllCreditAnalysisExcel: '/Seguimiento/seguimiento/infoAnalisisCrediticioUsuario/excel',
    },
    simulador: {
      getSocialReasons: '/Simulador/razonesSociales',
      getInstallations: '/Simulador/instalaciones',
      setPowerOptimiser: '/Simulador/optimizer',
      setPowerOptimiserManual: '/Simulador/optimizer/manual',
      getFees: '/Simulador/tarifas',
      getGeographicZones: '/Simulador/zonasGeograficas',
      getCampaigns: '/Simulador/campanas/{tarifaSips}/{zonaGeograficaCampaign}',
      simulateInvoiceCampaign: '/Simulador/factura/campaign',
      simulateInvoiceProduct: '/Simulador/factura/producto',
      downloadSimulation: '/Simulador/factura/download',
      getSipManual: '/Seguimiento/SipManual',
      getDraftContractExcelFile: '/Seguimiento/BorradorContratos/excel',
      getSipManualExcelFile: '/Seguimiento/SipManual/excel',
    },
    changeProduct: {
      putVerificationCif: '/CambioProducto/contrato/{codigoContratoOrigen}/verificacionCif',
      putChangeProduct: '/v3/Contratos/cambioProducto/monopunto',
      putChangeProductAsync: '/v3/Contratos/cambioProducto/monopunto/async',
      getContractFacther: '/ContratoMultiPunto/{codigoCrmContratoPadre}',
      getIdDraftMultipoint: '/CambioProducto/contratoMultipunto/{codigoContratoOrigen}/verificacionMultipuntoCif',
      newContractMultipoint: '/v3/Contratos/cambioProducto/multipunto/async'
    },
    renovateMultipoint: {
      queryCif: '/ContratoMultiPunto/Renovacion/{codigoContratoOrigen}/verificacionMultipuntoCif',
      putContract: '/v3/Contratos/renovacion/multipunto/async'
    },
    co2: {
      // screen: Draft
      getDraftList: '/HuellasCO2/huella/borradores',

      // screen: Historical
      getHistorical: '/HuellasCO2/huella/historicos',

      // screen: Parameterization
      getParamerization: '/HuellasCO2/factores/allFactores/{year}',
      getParamerizationExcel: '/HuellasCO2/factores/excel/{year}',
      postParamerization: '/HuellasCO2/factores/{year}',

      // screen: Flow new co2
      getMasterBusinessType: '/HuellasCO2/maestro/tiposEmpresa',
      getMasterBusinessSectors: '/HuellasCO2/maestro/sectoresEmpresa',
      getFactorsRoadTransportation: '/HuellasCO2/factores/transportesCarretera/{year}',
      getFactorsOtherTransportation: '/HuellasCO2/factores/otrosTransportes/{year}',
      getFactorsFixedInstallations: '/HuellasCO2/factores/instalacionesFijas/{year}',
      getFactorsMachineryWork: '/HuellasCO2/factores/maquinariaTrabajo/{year}',
      getFactorsRefrigerationEquipment: '/HuellasCO2/factores/equiposRefrigeracion/{year}',
      getFactorsLeaks: '/HuellasCO2/factores/fugas/{year}',
      getFactorsElectricityConsumption: '/HuellasCO2/factores/consumoElectricoInstalaciones/{year}',
      getFactorsElectricVehicleConsumption: '/HuellasCO2/factores/consumoVehiculosElectricos/{year}',

      // screen: results new co2
      getResultsCo2: '/HuellasCO2/resultados/{idHuella}',
      getResultsCo2File: '/HuellasCO2/resultado/fichero/{idHuella}',

      // Track
      postCO2: '/HuellasCO2/',
      deleteCO2: '/HuellasCO2/{id}',
      putCO2: '/HuellasCO2/huella',
      getCO2: '/HuellasCO2/huella/{id}',
      confirmCO2: '/HuellasCO2/huella/finalizado/{id}',
      postHistoricalCO2: '/HuellasCO2/historico/huella'
    },
    contracts: {
      getAllContracts: '/v3/Contratos/allContracts',
      getContractsStatus: '/v3/Maestros/estadosContratos/allContracts',
      getAllContractsExcel: '/v3/Contratos/allContracts/excel',
    },
    sipsData: {
      infoSipsUsuario: '/v3/Seguimiento/infoSipsUsuario',
      deleteSipsDataInfo: '/v3/Seguimiento/infoSipsUsuario',
      postSipsDataInfo: '/v3/Seguimiento/infoSipsUsuario',
      getAllInfoSipsExcel: '/v3/Seguimiento/infoSipsUsuario/excel',
      getInfoSipsExcel: '/v3/Seguimiento/ficheroSips/excel',
    }
  }
};
